import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import Industries from "@/pages/Industries";
import Products from "@/pages/Products";
import Technology from "@/pages/Technology";
import Research from "@/pages/Research";
import Studio from "@/pages/Studio";
import VDL from "@/pages/VDL";
import Careers from "@/pages/Careers";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import FAQ from "@/pages/FAQ";
import IndustryDetail from "@/pages/IndustryDetail";
import RoleDetail from "@/pages/RoleDetail";
import Contact from "@/pages/Contact";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Security from "@/pages/Security";
import NotFound from "@/pages/NotFound";

// Admin-only routes are rarely visited by the public and the post editor
// pulls in Tiptap/ProseMirror (~130KB gzipped) — lazy-load so that weight
// never ships in the main bundle every visitor downloads.
const Admin = lazy(() => import("@/pages/Admin"));
const InsightsAdmin = lazy(() => import("@/pages/InsightsAdmin"));
const PostEditor = lazy(() => import("@/pages/PostEditor"));
const FAQAdmin = lazy(() => import("@/pages/FAQAdmin"));
const FAQEditor = lazy(() => import("@/pages/FAQEditor"));
const PostPreview = lazy(() => import("@/pages/PostPreview"));

function App() {
    return (
        <ThemeProvider>
            <div className="App">
                <BrowserRouter>
                    <Suspense fallback={null}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/industries" element={<Industries />} />
                        <Route path="/industries/:slug" element={<IndustryDetail />} />
                        <Route path="/industries/:industry/:slug" element={<CaseStudyDetail />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/technology" element={<Technology />} />
                        <Route path="/research" element={<Research />} />
                        <Route path="/studio" element={<Studio />} />
                        <Route path="/vdl" element={<VDL />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/careers/:id" element={<RoleDetail />} />
                        <Route path="/insights" element={<Insights />} />
                        <Route path="/insights/:slug" element={<InsightDetail />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/security" element={<Security />} />
                        <Route path="/studio-admin" element={<Admin />} />
                        <Route path="/studio-admin/insights" element={<InsightsAdmin />} />
                        <Route path="/studio-admin/insights/new" element={<PostEditor />} />
                        <Route path="/studio-admin/insights/:id" element={<PostEditor />} />
                        <Route path="/studio-admin/insights/preview" element={<PostPreview />} />
                        <Route path="/studio-admin/faqs" element={<FAQAdmin />} />
                        <Route path="/studio-admin/faqs/new" element={<FAQEditor />} />
                        <Route path="/studio-admin/faqs/:id" element={<FAQEditor />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    </Suspense>
                </BrowserRouter>
                <Toaster position="bottom-right" />
            </div>
        </ThemeProvider>
    );
}

export default App;
